import * as React from "react";
import { Receipt, Session, TransactionHistory } from "../types";
import SummaryReceipt from "../common/SummaryReceipt";
import t from "../i18n";
//import TrxBlock from "../common/TrxBlock";
import { Link } from "react-router-dom";
import { format } from "../utils";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";
import { TopupService } from "../services/topup-service";
import { ProductCategory, SkuCategory } from "../types-enums";

declare type TrxSuccessfulProps = { receipt: Receipt, history: TransactionHistory[], onRepeat: (sessionId: string, cateory: ProductCategory) => void, isGuestCheckout: boolean }
export default class TrxSuccessful extends React.Component<TrxSuccessfulProps> {
    render() {
        const receipt = this.props.receipt;
        if (!receipt) return null;
        const session = toSession(this.props.receipt);
        const ccPayment = receipt.paymentDetails.find((p: any) => p.paymentMethod === 1);
        const ppPayment = receipt.paymentDetails.find((p: any) => p.paymentMethod === 2);
        const totalAmount = session.netCharge;
        const totalPaymentUSD = session.isDollarPayment ? session.netChargeInUSD : undefined;
        const autoTopupQS = `?cc=${receipt.country.countryCode}&mn=${receipt.mobileNumber}&a=${receipt.faceValue}&p=${receipt.product.productId}`;
        let slot1: JSX.Element;
        let slot2: JSX.Element;
        if (ccPayment) {
            slot1 = (
                <div className="row summary-row font-weight-600">
                    <div className="col-sm-6 col-7">
                        <div className="blue-text">{t.receipt("amount_charged")}</div>
                    </div>
                    <div className="col-sm-4 d-none d-sm-block" />
                    <div className="col-sm-2 col-5 text-right">
                        {format(totalAmount, true)} {session.sourceCurrencyCode}
                    </div>
                    <div className="col-12" style={{ textTransform: "none" }}>{t.receipt("from_cc")} xxxx-xxxx-{ccPayment.ccFourDigits}</div>
                </div>
            );
        } else if (ppPayment) {
            slot1 = <div className="row summary-row font-weight-600">
                <div className="col-sm-6 col-7">
                    <div className="blue-text">{t.receipt("amount_charged")}</div>
                </div>
                <div className="col-sm-4 d-none d-sm-block" />
                <div className="col-sm-2 col-5 text-right">
                    {session.isDollarPayment ? `${format(totalPaymentUSD, true)} USD` : `${format(totalAmount, true)} ${format(session.sourceCurrencyCode)}`}
                </div>
                <div className="col-12" style={{ textTransform: "none" }}>{t.receipt("from_paypal")}</div>
            </div>
        } else {
            slot1 = <div>
                {/* <label>{t.topup("from_reward_points")}</label> */}
            </div>
        }
        if (this.props.receipt.skuCategory == SkuCategory.GiftCard || this.props.receipt.skuCategory == SkuCategory.Pin) {
            slot2 = (<div className="d-flex align-items-center justify-content-between">
                <span style={{ flexBasis: 110, marginRight: 15 }}>
                    {t.topup("transaction_id", { transactionId: this.props.receipt.transactionId })}
                </span>
                <a className={classNames(['button', css(btnStyles.default), 'p-2', 'text-center'])} onClick={this.resendGiftCardEmail}>{t.receipt("resend_email")}</a>
            </div>);
        }
        else {
            slot2 = (<div className="d-flex align-items-center justify-content-between">
                <span style={{ flexBasis: 110, marginRight: 15 }}>
                    {t.topup("transaction_id", { transactionId: this.props.receipt.transactionId })}
                </span>
                { !this.props.isGuestCheckout && <Link to={{ pathname: "/auto-topup", search: autoTopupQS }}
                    className={classNames(['button', css(btnStyles.default), 'p-2', 'text-center'])}>{t.topup("auto_balance_title")}</Link>}
            </div>);
        }
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.menu("receipt")}</h2>
            </div>
            <SummaryReceipt session={session} slot1={slot1} slot2={slot2} />
            {/* <h5>{t.menu("order_history")}</h5>
            <div className="row">
                {this.props.history.map(h => <TrxBlock key={h.transactionId} trx={h} onRepeat={this.props.onRepeat} />)}
            </div> */}
        </div>
    }

    resendGiftCardEmail = async () => {
        const receipt = this.props.receipt;
        var result = await TopupService.resendGiftCardEmail(receipt.transactionId);
        if(result.responseCode === 0)
        {
            alert(result.responseMessage);
        }
        else 
        {
            alert(t.messages("resend_email_error"));
        }
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}
function toSession(trx: Receipt) {
    const pp = trx.paymentDetails.find(p => p.paymentMethod === 2);
    const trxStatus = TopupService.getTransactionStatus(trx);
    return {
        sessionId: '',
        userId: '',
        countryCode: '',
        productId: 0,
        productName: trx.product.name,
        productDisclaimer: trx.product.disclaimer,
        sms: '',
        promoCode: '',
        rewardPointsBalance: 0,
        rewardPointsEarned: 0,
        rewardPointsUsed: trx.rewardPointsUsed || 0,
        processingFee: trx.processingFee,
        netCharge: trx.netCharge,
        netChargeInUSD: trx.netChargeInUSD,
        smsCharge: trx.smsCharge,
        coverSalesTax: trx.coverSalesTax,
        isValidMobileNumber: true,
        internationalCode: +trx.internationalCountryCode,
        mobileNumber: trx.mobileNumber,
        localCurrencyAmount: trx.transactionRecharges ? trx.transactionRecharges.localCurrencyAmount : undefined,
        faceValue: trx.faceValue,
        sourceCurrencyCode: trx.sourceCurrencyCode,
        currencyCode: trx.currencyCode,
        // paymentMessage: paymentMessage,
        salesTax: trx.salesTax,
        timeCreated: trx.transactionDate,
        carrierPromotion: trx.trxCarrierPromotion,
        promoCodeDiscount: trx.promoCodeDiscount,
        rewardPointDiscount: trx.rewardPointDiscount,
        skuCategory: trx.skuCategory,
        skuShortDescription: trx.skuShortDescription,
        isDollarPayment: pp ? pp.isDollarPayment : undefined,
        recipientEmail: trx.transactionRecharges ? trx.transactionRecharges.recipientEmail : undefined,
        recipientFullName: trx.transactionRecharges ? trx.transactionRecharges.recipientFullName : undefined,
        recipientMobile: trx.transactionRecharges ? trx.transactionRecharges.recipientMobile : undefined,
        recipientMessage: trx.transactionRecharges ? trx.transactionRecharges.recipientMessage : undefined,
        giftCertificateUrl: trx.transactionRecharges ? trx.transactionRecharges.giftCertificateUrl : undefined,
        cardNumber: trx.transactionRecharges ? trx.transactionRecharges.cardNumber : undefined,
        pin: trx.transactionRecharges ? trx.transactionRecharges.pin : undefined,
        transactionStatus: trxStatus,
        guestEmail: trx.guestEmailAddress,
    } as Session;
}
